import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { routes } from './app/routes';
import { EventBusProvider } from '@bus/EventBusProvider';
import './styles/global.css';

const router = createBrowserRouter(routes);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element #root not found');

createRoot(rootEl).render(
  <StrictMode>
    <EventBusProvider sessionId={crypto.randomUUID()}>
      <RouterProvider router={router} />
    </EventBusProvider>
  </StrictMode>,
);
